<template>
  <div v-if="!showCreateSideBar" class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between mb-4">
      <p class="text-3xl font-bold">Opporturnity</p>
      <div class="flex flex-row items-center justify-between space-x-4">
        <div class="relative group">
          <input type="text" v-model="searchText" class="bg-light-gray px-4 py-3 rounded-full font-sans"
            placeholder="Search Opporturnity" v-on:keyup.enter="handleSearch" />
          <MagnifyingGlassIcon class="absolute bottom-3 right-3 w-6 h-6 text-gray" />
        </div>
        <BaseRoundedButton @click="handleShowCreateSideBar">
          Create Opporturnity
        </BaseRoundedButton>
      </div>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b border-light-gray">
          <tr class="text-left text-gray text-md">
            <th class="py-2 font-normal text-center">Thumbnail</th>
            <th class="py-2 font-normal">Title</th>
            <th class="py-2 font-normal hidden md:block">Content</th>
            <th class="py-2 font-normal">Tags</th>
            <th class="py-2 font-normal">Created By</th>
            <th class="py-2 font-normal text-center">Status</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contentData in contents" :key="contentData.id" class="text-lg">
            <td>
              <div class="flex justify-center">
                <img class="rounded-lg rectangle_img w-32 object-cover my-2" :src="contentData.thumbnail_image"
                  alt="" />
              </div>
            </td>
            <td class="truncate-2-lines px-2 align-top">
              {{ contentData.title }}
            </td>
            <td class="px-2 w-96 align-top">
              <div class="w-96 truncate-2-lines text-gray" v-html="contentData.content"></div>
            </td>
            <td>
              <div v-if="contentData.tag">
                <div v-for="(tag, index) in contentData.tag.split(',')" :key="index" class="
                    px-4
                    py-1
                    bg-light-gray
                    text-gray
                    rounded-full
                    w-max
                    flex
                    my-1
                  ">
                  {{ tag }}
                </div>
              </div>
            </td>
            <td class="text-blue text-center">
              {{ contentData.created_by ? contentData.created_by.name : 'Unknown' }}
            </td>
            <td>
              <div class="flex justify-center">
                <div v-if="contentData.status == '0'" class="px-4 py-1 bg-light-red text-red rounded-full w-max">
                  <p>Unpublish</p>
                </div>
                <div v-else class="px-4 py-1 bg-light-blue text-blue rounded-full w-max">
                  <p>Published</p>
                </div>
              </div>
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton>
                    <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                  </MenuButton>
                  <MenuItems class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-0
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-12/12
                    ">
                    <MenuItem @click="handleEdit(contentData)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <PencilIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Edit</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleUpdateStatus(contentData, '1')" v-if="contentData.status == '0'"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <EyeIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Publish</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleUpdateStatus(contentData, '0')" v-if="contentData.status == '1'"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <EyeSlashIcon class="text-red w-5 h-5 mr-4" />
                      <p class="text-red">Unpublish</p>
                    </div>
                    </MenuItem>
                    <MenuItem @click="handleDeleteContent(contentData.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <TrashIcon class="text-red w-5 h-5 mr-4" />
                      <p class="text-red">Delete</p>
                    </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- loading animation -->
    <div class="min-h-full flex flex-col space-y-4 items-center justify-center" v-if="isLoading">
      <div class="animate-ping w-12 h-12 bg-light-gray rounded-full"></div>
      <p class="text-gray text-lg font-sans font-light">Loading data</p>
    </div>
    <!-- no data icon -->
    <div class="min-h-full flex items-center justify-center" v-if="!contents.length && !isLoading">
      <div class="flex flex-col">
        <div class="flex justify-center">
          <InboxIcon class="text-gray w-12 h-12 md:w-24 md:h-24" />
        </div>
        <p class="text-gray text-2xl font-sans font-light">No data found!</p>
      </div>
    </div>
    <div class="mt-auto flex justify-end">
      <BasePagination :pageCount="meta.last_page" @navigate-to-page="handlePagination($event)" />
    </div>
  </div>
  <!-- create new Opporturnity -->
  <div v-else class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <div class="flex justify-between">
        <div class="flex space-x-2 items-center">
          <div @click="handleShowCreateSideBar" class="group p-2 rounded-full hover:bg-light-blue cursor-pointer">
            <ArrowSmallLeftIcon class="w-6 h-6 text-black group-hover:text-blue" />
          </div>
          <h1 v-if="!updateFlag" class="text-blue md:text-2xl">
            Create New Opporturnity
          </h1>
          <h1 v-else class="text-blue md:text-2xl">Update Content</h1>
        </div>
        <div class="flex flex-row items-center justify-between space-x-4">
          <BaseRoundedButton v-if="!updateFlag" @click="handleSaveContent" class="w-full">
            <p class="hidden md:block">Create Opporturnity</p>
            <p class="md:hidden block text-sm">Create</p>
          </BaseRoundedButton>
          <BaseRoundedButton v-else @click="handleSaveUpdate" class="w-full">
            <p class="hidden md:block">Save Update</p>
            <p class="md:hidden block text-sm">Save</p>
          </BaseRoundedButton>
        </div>
      </div>
      <!-- body -->
      <div class="flex flex-col space-y-2">
        <div class="md:flex md:space-x-16 items-center">
          <div class="md:w-2/4 w-full relative">
            <div @click="handleFileImport" class="group py-4 cursor-pointer">
              <p class="text-gray mb-2 font-normal">Thumbnail Image</p>
              <!-- hiddden image file input field that triger when profile image container clicked -->
              <input ref="imageFileUploader" class="hidden" type="file" name="profileImage" id="profileImage"
                accept="image/*" @change="handleFileUpload($event)" />
              <div class="w-full">
                <img v-if="thumbnailUrl" class="w-full rectangle_img object-cover rounded-lg mb-2" :src="thumbnailUrl"
                  alt="" />
                <img v-else class="w-full rectangle_img object-cover rounded-lg mb-2"
                  src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg" alt="" />
              </div>
              <p v-if="thumbnailUrl" class="
                  cursor-pointer
                  text-center text-lg
                  font-sans
                  text-blue
                  group-hover:underline
                ">
                Change thumbnail image
              </p>
              <p v-else class="
                  cursor-pointer
                  text-center text-lg
                  font-sans
                  text-blue
                  group-hover:underline
                ">
                Add thumbnail image
              </p>
            </div>
            <div v-show="thumbnailUrl" @click="handleClearImage" class="
                flex
                items-center
                justify-center
                p-3
                bg-red
                rounded-full
                absolute
                -right-6
                top-6
                cursor-pointer
              ">
              <TrashIcon class="text-white h-6 w-6" />
            </div>
          </div>
          <div class="md:w-2/4 w-full">
            <base-text-input v-model="title" name="title" isAutoComplete="off" inputPlaceHolder="opportunity"
              label="Opporturnity Name" />
            <base-text-input v-model="tag" name="tag" inputPlaceHolder="use tags by comma, new opportunity, ..."
              isAutoComplete="off" label="Tags" />
          </div>
        </div>
        <!-- rich text editor -->
        <div>
          <p class="text-gray">Content</p>
          <vue-editor useCustomImageHandler @imageAdded="handleImageAdded" v-model="content" class="min-h-full mb-6" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MagnifyingGlassIcon,
  TrashIcon,
  EllipsisVerticalIcon,
  EyeIcon,
  EyeSlashIcon,
  PencilIcon,
  ArrowSmallLeftIcon
} from "@heroicons/vue/24/outline";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import VueEditor from "../components/BaseQuillEditor.vue";
import userService from "../Services/user.service";
import { useToast } from "vue-toastification";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import BasePagination from "../components/BasePagination.vue";
export default {
  name: "ManageOpporturnity",
  components: {
    MagnifyingGlassIcon,
    TrashIcon,
    EllipsisVerticalIcon,
    EyeIcon,
    EyeSlashIcon,
    PencilIcon,
    BaseRoundedButton,
    BaseTextInput,
    VueEditor,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    BasePagination,
    ArrowSmallLeftIcon
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      isLoading: true,
      showCreateSideBar: false,
      thumbnailUrl: "",
      imageFile: "",
      title: "",
      tag: "",
      content: "",
      params: new URLSearchParams(),
      contents: [],
      meta: [],
      searchTex: "",
      updateFlag: false,
      tempId: "",
    };
  },
  methods: {
    getcontentList() {
      this.params.set("type", "3");

      userService.getContent(this.params).then((resposne) => {
        this.contents = resposne.data.data;
        this.meta = resposne.data.meta;
        this.isLoading = false;
      });
    },
    handleShowCreateSideBar() {
      this.showCreateSideBar = !this.showCreateSideBar;
      this.updateFlag = false;
      if (!this.updateFlag) {
        this.thumbnailUrl = "";
        this.imageFile = "";
        this.title = "";
        this.tag = "";
        this.content = "";
      }
    },
    handleFileImport() {
      this.$refs.imageFileUploader.click();
    },
    handleFileUpload(event) {
      this.imageFile = event.target.files[0];
      this.thumbnailUrl = URL.createObjectURL(this.imageFile);
    },
    handleClearImage() {
      this.thumbnailUrl = "";
      this.imageFile = "";
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);

      userService
        .storeImage(formData)
        .then((response) => {
          const url = response.data.data.url;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSaveContent() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("thumbnail_image", this.imageFile);
      formData.append("content", this.content);
      formData.append("status", "1");
      formData.append("type", "3");
      formData.append("tag", this.tag);

      userService
        .storeContent(formData)
        .then(() => {
          this.$Progress.finish();
          this.thumbnailUrl = "";
          this.imageFile = "";
          this.title = "";
          this.tag = "";
          this.content = "";
          this.getcontentList();
          this.showCreateSideBar = false;
          this.toast.success("Create Opporturnity Successful.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Something went wrong! Can not create Opporturnity");
        });
    },
    handleUpdateStatus(data, status) {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title", data.title);
      formData.append("content", data.content);
      formData.append("status", status);
      formData.append("type", "3");
      formData.append("tag", data.tag);

      userService
        .storeUpdateContent(data.id, formData)
        .then(() => {
          this.$Progress.finish();
          this.getcontentList();
          this.toast.success("Update content status success.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot Update content status.");
        });
    },
    handleDeleteContent(id) {
      this.$Progress.start();
      userService
        .delContent(id)
        .then(() => {
          this.$Progress.finish();
          this.getcontentList();
          this.toast.success("Delect Content successfully.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Error! Delect Content.");
        });
    },
    handleSearch() {
      this.params.set("search", this.searchText);
      this.getcontentList(this.params);
    },
    handleEdit(value) {
      this.thumbnailUrl = value.thumbnail_image;
      this.title = value.title;
      if (value.tag == !'null') {
        this.tag = value.tag;
      }
      this.content = value.content;
      this.showCreateSideBar = !this.showCreateSideBar;
      this.updateFlag = true;
      this.tempId = value.id;
    },
    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("content", this.content);
      formData.append("status", "1");
      formData.append("type", "3");
      formData.append("tag", this.tag);
      if (this.imageFile || !this.thumbnailUrl) {
        formData.append("thumbnail_image", this.imageFile);
      }

      userService
        .storeUpdateContent(this.tempId, formData)
        .then(() => {
          this.$Progress.finish();
          this.thumbnailUrl = "";
          this.imageFile = "";
          this.title = "";
          this.tag = "";
          this.content = "";
          this.updateFlag = "";
          this.getcontentList();
          this.showCreateSideBar = false;
          this.toast.success("Update Successful.");
        })
        .catch(() => {
          this.$Progress.fail();
          this.toast.error("Error! Cannot Update content!");
        });
    },
    handlePagination(value) {
      this.params.set("page", value);
      this.getcontentList(this.params.toString());
    },
  },
  created() {
    this.$Progress.start();
    this.getcontentList();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.rectangle_img {
  aspect-ratio: 16/9;
}

.truncate-2-lines {
  max-height: 3.6em;
  /* double the size of line-height */
  line-height: 1.8em;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
